import { MockMethod } from 'vite-plugin-mock';

export default [
    {
        url: '/mock/common/footer/list',
        method: 'post',
        response: (option:any) =>
        {
            return {
                code: 0,
                data: [
                    // {
                    //     name: '关于我们',
                    //     items: [
                    //         {
                    //             name: '核心技术',
                    //             route: '/technology'
                    //         },
                    //         {
                    //             name: '产品中心',
                    //             route: '/production'
                    //         },
                    //         {
                    //             name: '新闻资讯',
                    //             route: '/news'
                    //         },
                    //         {
                    //             name: '关于紫为云',
                    //             route: '/about'
                    //         },
                    //         {
                    //             name: '加入我们',
                    //             route: '/join'
                    //         }
                    //     ]
                    // },
                    {
                        name: '研究中心',
                        items: [
                            {
                                name: '清华大学媒体大数据认知计算研究中心',
                                route: ''
                            },
                            {
                                name: '清华大学信息认知与智能系统研究所',
                                route: ''
                            },
                            {
                                name: '清华珠三角研究院跨媒体智能与类脑机器人技术研究中心',
                                route: ''
                            }
                        ]
                    }
                ],
                message: 'success'
            };
        }
    },
    {
        url: '/mock/common/navigation/list',
        method: 'post',
        response: (option:any) =>
        {
            return {
                code: 0,
                data: [
                    {
                        name: '首页',
                        routerGroupName: 'home',
                        route: '/'
                    },
                    {
                        name: '核心技术',
                        routerGroupName: 'technology',
                        route: '/technology/ar',
                        children: [
                            {
                                name: 'AR交互技术',
                                route: '/technology/ar'
                            },
                            {
                                name: '沉浸式计算',
                                route: '/technology/compute'
                            },
                            {
                                name: '多模态算法',
                                route: '/technology/ai'
                            },
                            {
                                name: '数据处理',
                                route: '/technology/data-process'
                            }
                        ]
                    },
                    {
                        name: '产品中心',
                        routerGroupName: 'production',
                        route: '/production',
                        children: [
                            {
                                name: '交互智能硬件',
                                route: '/production/ai-hardware'
                            },
                            {
                                name: 'AR增强现实产品',
                                route: '/production/ar-virtual'
                            },
                            {
                                name: '交互智能平台产品',
                                route: '/production/ai-interaction'
                            },
                            {
                                name: '沉浸式场景解决方案',
                                route: '/production/immersion-solution'
                            },
                            {
                                name: 'AI通用产品',
                                route: '/production/ai-universal'
                            },
                            // {
                            //     name: 'AI创新创意',
                            //     route: '/production/ai-creativity'
                            // },
                            {
                                name: 'AI鲜世界',
                                route: '/production/ai-fresh-world'
                            },
                            {
                                name: '体验中心',
                                route: '/production/ai-experience'
                            }
                        ]
                    },
                    {
                        name: '新闻资讯',
                        routerGroupName: 'news',
                        route: '/news'
                    },
                    {
                        name: '关于紫为云',
                        routerGroupName: 'about',
                        route: '/about'
                    },
                    {
                        name: '加入我们',
                        routerGroupName: 'join',
                        route: '/join'
                    }

                ],
                message: 'success'
            };
        }
    }

] as MockMethod[];
